'use client'

import * as React from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import { Toggle as TogglePrimitive } from 'radix-ui'

const toggleVariants = cva(
	[
		'inline-flex items-center justify-center gap-2 rounded-md font-medium text-sm ring-offset-background transition-colors',
		'hover:bg-slate-200 hover:text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
		'data-[state=on]:bg-primary data-[state=on]:text-primary-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
	],
	{
		defaultVariants: {
			size: 'default',
			variant: 'default',
		},
		variants: {
			size: {
				default: 'h-10 min-w-10 px-3',
				lg: 'h-11 min-w-11 px-5',
				sm: 'h-[32px] min-w-[32px] px-2.5',
			},
			variant: {
				default: 'bg-transparent',
				outline:
					'border bg-transparent hover:bg-accent hover:text-accent-foreground',
			},
		},
	},
)

const Toggle = React.forwardRef<
	React.ElementRef<typeof TogglePrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
		VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
	<TogglePrimitive.Root
		className={cn(toggleVariants({ className, size, variant }))}
		ref={ref}
		{...props}
	/>
))

Toggle.displayName = TogglePrimitive.Root.displayName

export { Toggle, toggleVariants }
